<script lang="ts">
  import { get,  writable } from "svelte/store";
  import { onMount } from "svelte";
  import { createEventDispatcher } from "svelte";
import SearchDropdown from "../../components/Form/Fields/Dropdown/SearchDropdown.svelte";
import FormField from "../../components/Form/FormField.svelte";
import { Table } from "../../components/Table";
import type { ICompanyInvoicePayment } from "../../entities/company-invoice-payment";
import type { ICompanyInvoiceEmailRequestDTO, IDropdownItem } from "../../services/DTO";
import type { ICompanyInvoicePaymentDTO } from "../../services/DTO/entity/company-invoice-payment-dto";
import type { ICompanyInvoicePaymentEmailPreviewDTO } from "../../services/DTO/entity/company-invoice-payment-email-preview-dto";
import { companyInvoicePaymentEmailPreviewDtoFields } from "../../utils/TableFields/company-invoice-payment-email-preview-dto.fields";

  export let title: string = "Conferma invio email/pec";
  export let message: string = "Seleziona il tipo di invio:";
  export let confirmButtonText: string = "Invia";
  export let declineButtonText: string = "Annulla";
  export let open: boolean = false;
  export let targets: ICompanyInvoicePaymentDTO[] = [];

  const dispatch = createEventDispatcher();

  let emailType : number = 0;
  let items : IDropdownItem[] = [{
    oid: 0, label: 'ESTRATTO CONTO'
  },{
    oid: 1, label: 'SOLLECITO'
  }];

  let missingPec : string = "";
  let preview : ICompanyInvoicePaymentEmailPreviewDTO[] = [];
  
  $: {
    preview = [];
    missingPec = "";
		targets.forEach(targ => {
    let found = false;
    preview.forEach(prev => {
      if (!found && prev.oid == targ.company.oid)
      {
        prev.importo += targ.payment.importorata;
        prev.numeroFattura += "," + targ.invoice.numeroFattura; 
        prev.paymentsOids.push(targ.payment.oid);
        found = true;
      }      
    });

    if (!found)
    {
      let p: ICompanyInvoicePaymentEmailPreviewDTO = {
        oid : targ.company.oid,        
        importo : targ.payment.importorata,
        numeroFattura : targ.invoice.numeroFattura,
        company: targ.company.name,
        email: targ.email,
        pec: targ.pec,
        paymentsOids: [targ.payment.oid]       
      }  
      preview.push(p);
      if (p.pec == null)
        missingPec += p.company + ",";
    }      
  });
	}
  
  


  function handleConfirmClick(event: Event) {
    open = false;
    dispatch("confirm", {pec: emailType!=0, results: preview});
  }

  function handleDeclineClick(event: Event) {
    open = false;
    dispatch("decline", event);
  }
</script>

{#if open}
  <div class="modal is-active">
    <div class="modal-background" />

    <div class="modal-card" style="width:80%;">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {title}
        </p>

        <button
          class="delete"
          aria-label="close"
          on:click={handleDeclineClick}
        />
      </header>

      <section class="modal-card-body">
        <p>{message}</p>
        <p>
          <FormField>
            <SearchDropdown
              name=""              
              placeholder="Seleziona..."
              required={true}
              items={items}
              bind:value={emailType}
            />
          </FormField>
        </p>
        <br/>
        <br/>
        <Table
          loading={false}
          fields={companyInvoicePaymentEmailPreviewDtoFields}
          records={preview}
          pagination={null}
          createEnabled={false}
          showEnabled={false}
          deleteEnabled={false}
          downloadEnabled={false}
          customEnabled={false}
        />
        <br/>
        {#if emailType==1 && missingPec!=""}
        <div class="notification is-danger"> 
          Per poter inviare la pec di sollecito è necessario che sia presente l'indirizzo pec.<br/>
          Sono state trovate le seguenti aziende senza pec impostata: <strong>{missingPec}</strong><br/>
          Aggiornare gli indirizzi per queste aziende e rieseguire la procedura di invio solleciti.
        </div>
        {/if}
      </section>

      <footer class="modal-card-foot modal-confirm-modal-card-foot">
        <button class="button is-danger" on:click={handleConfirmClick}
          disabled={emailType==1 && missingPec!=""}
        >
          {confirmButtonText}
        </button>

        <button class="button" on:click={handleDeclineClick}>
          {declineButtonText}
        </button>
      </footer>
    </div>
  </div>
{/if}

<style>
  .modal-confirm-modal-card-foot {
    display: inline-block;
    text-align: center;
  }
</style>
